import { PAGES } from "@/pages/legalTextos";
import HOME_ES from "@/i18n/home/es";
import { paginaDe, rutaLimpia } from "./datos";
import { articuloLd, faqPage, meta, migas, sitioWeb, software } from "./cabecera";
import { RUTAS_CON_IMAGEN } from "./enlaces";

const CANARIAS = "/software-reformas-canarias";
const rastro = (p) => (p.tipo === "local" && p.ruta !== CANARIAS ? [["Canarias", CANARIAS], [p.h1, p.ruta]] : [[p.h1 || p.titulo_seo, p.ruta]]);
// La imagen elegida en Administración SEO manda; si no hay, la propia de la página.
const imagenDe = (p, ruta) => p?.imagen || (ruta === "/" ? "/og-portada.jpg" : RUTAS_CON_IMAGEN.has(ruta) ? `/og${ruta}.jpg` : "");
// Preguntas que se ven en la portada (en español, el idioma por defecto de la web).
const FAQ_PORTADA = HOME_ES.faq.items.map((f) => ({ pregunta: f.q, respuesta: f.a }));

// Descripción de una página legal a partir de sus apartados (sin inventar texto).
const apartado = (h) => {
  const s = h.replace(/[¿?]/g, "").replace(/\s*\([^)]*\)/g, "").trim();
  return /^[A-ZÁÉÍÓÚÑ][a-záéíóúñ]/.test(s) && !/^(NuvliPro|Plan )/.test(s) ? s[0].toLowerCase() + s.slice(1) : s;
};
export function resumenLegal(pg) {
  const inicio = `${pg.title} de NuvliPro: `;
  const elegidos = [];
  for (const a of pg.sections.map(([h]) => h).filter((h) => h !== "Actualizaciones").map(apartado)) {
    if ((inicio + [...elegidos, a].join(", ")).length > 150) break;
    elegidos.push(a);
  }
  return `${inicio}${elegidos.length > 1 ? `${elegidos.slice(0, -1).join(", ")} y ${elegidos.at(-1)}` : elegidos[0] || ""}.`;
}

// Título, descripción, canónica, Open Graph y datos estructurados de cada ruta pública (mismo cálculo en el navegador y al prerenderizar).
export function metaDe(rutaPedida, d) {
  const ruta = rutaLimpia(rutaPedida);
  const legal = ruta.match(/^\/legal\/([\w-]+)$/);
  if (legal) {
    const pg = PAGES[legal[1]];
    // En borrador: fuera de Google (noindex) y del sitemap, pero se puede rastrear y se sigue viendo en la web.
    return pg ? meta({ ruta, titulo: `${pg.title} | NuvliPro`, descripcion: resumenLegal(pg), d, jsonld: [migas([[pg.title, ruta]])],
      robots: pg.borrador ? "noindex, follow" : undefined }) : null;
  }
  if (!d) return null;
  const p = paginaDe(d, ruta);
  if (ruta === "/") return meta({ ruta, titulo: p?.titulo_seo, descripcion: p?.descripcion_seo, imagen: imagenDe(p, ruta), d, jsonld: [sitioWeb(), software(d), faqPage(FAQ_PORTADA)] });
  const cat = ruta.match(/^\/blog\/categoria\/([\w-]+)$/);
  if (cat) {
    const c = d.categorias.find((x) => x.slug === cat[1]);
    if (!c) return null;
    return meta({ ruta, titulo: `${c.nombre} | Blog de NuvliPro`, descripcion: c.descripcion || paginaDe(d, "/blog")?.descripcion_seo, d,
      jsonld: [migas([["Blog", "/blog"], [c.nombre, ruta]])] });
  }
  const art = ruta.match(/^\/blog\/([\w-]+)$/);
  if (art) {
    const a = d.articulo?.slug === art[1] ? d.articulo : d.articulos.find((x) => x.slug === art[1]);
    if (!a) return null;
    return meta({ ruta, titulo: a.titulo_seo || `${a.titulo} | NuvliPro`, descripcion: a.descripcion_seo || a.resumen, imagen: a.imagen,
      tipo: "article", d, jsonld: [articuloLd(a, ruta), migas([["Blog", "/blog"], [a.titulo, ruta]])] });
  }
  if (!p) return null;
  const extra = ruta === "/preguntas-frecuentes" ? [faqPage(d.faqs)] : ruta === "/precios" || p.tipo === "funcion" ? [software(d)]
    : p.tipo === "landing" ? [software(d), faqPage(p.faqs)] : p.faqs?.length ? [faqPage(p.faqs)] : [];
  return meta({ ruta, titulo: p.titulo_seo, descripcion: p.descripcion_seo, imagen: imagenDe(p, ruta), d, jsonld: [...extra, migas(rastro(p))] });
}
